var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconsCheckmark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#072F3D",
    d: "M5 19V5h7V3H3v18h18v-9h-2v7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#38BCEE",
    d: "M12 16l-5-5 2-2 2.895 2.894L19 4l2 2-7.105 7.894L14 14l-1.991 1.989L12 16z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsCheckmark);
export default __webpack_public_path__ + "static/media/icons-checkmark.740b6931c03974d8c075aa2789a078ee.svg";
export { ForwardRef as ReactComponent };